import React, {Component} from 'react';
//children
import Modal, { ModalHeader, ModalBody, ModalFooter } from '../../../common/Modal';
import SweepSelectionList from './SweepSelectionList';

export class SweepSelectionsDialog extends Component {

  constructor(props) {
    super(props);
    this.state = {
      sweepSelections: []
    }
  }

  componentDidMount() {
    var sweepSelections = this.props.sweepGroup ? (this.props.sweepGroup.sweepInstructions ? this.props.sweepGroup.sweepInstructions : []) : [];
    this.setState({sweepSelections});
  }

  componentWillReceiveProps(nextProps) {
    var sweepSelections = nextProps.sweepGroup ? (nextProps.sweepGroup.sweepInstructions ? nextProps.sweepGroup.sweepInstructions : []) : [];
    this.setState({sweepSelections});
  }

  onSelectionChanged = (sweepSelections) => {
    this.setState({sweepSelections});
  }

  _onSetSelections = () => {
    this.props._onSetSelections(this.props.currentSelectedGroupIndex, this.state.sweepSelections);
    this.props.toggleDialog();
  }

  _onClearSelections = () => {
    this.setState({sweepSelections: []});
  }

  render() {
    return (
      <Modal show={this.props.showDialog} onClose={this.props.toggleDialog} bsClass={this.props.bsClass}>
        <ModalHeader title={this.props.modalTitle} />
        <ModalBody>
          <SweepSelectionList sweepInstructions={this.props.sweepInstructions || []}
                              accounts={this.props.availableAccountsList || []}
                              sweepSelections={this.state.sweepSelections}
                              onSelectionChanged={this.onSelectionChanged} 
                              sweepTypes={this.props.sweepTypes}
                              pageJson={this.props.pageJson}
                              lang={this.props.lang}/>
        </ModalBody>
        <ModalFooter>
          <button className="gdocs-btn-default clear-selections" onClick={this._onClearSelections} disabled={false}>
          {this.props.clearBtn}
          </button>
          <button className="gdocs-btn-default cancel-btn" onClick={this.props.toggleDialog} disabled={false}>
          {this.props.cancelBtn}
          </button>
          <button className="gdocs-btn-primary" onClick={this._onSetSelections} disabled={false}>
          {this.props.redBtn}
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsCashCon/Modals.js